import { ReactNode, useState } from 'react';
import { Box } from '@nimbus-ds/components';
import { ChevronDownIcon, ChevronUpIcon } from '@nimbus-ds/icons';
import Stack from '../Stack';

interface CollapsibleProps {
  header: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
}

function Collapsible({
  header,
  children,
  defaultOpen = false,
}: CollapsibleProps): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);
  const handleToggle = () => setIsOpen((prevOpen) => !prevOpen);

  return (
    <Box cursor="pointer">
      <Stack column align="stretch" spacing="tight">
        <Box onClick={handleToggle}>
          <Stack justify="space-between" spacing="none" align="baseline">
            <Stack column align="stretch">
              {header}
            </Stack>
            <Stack.Item>
              {isOpen ? <ChevronDownIcon /> : <ChevronUpIcon />}
            </Stack.Item>
          </Stack>
        </Box>
        {isOpen && children}
      </Stack>
    </Box>
  );
}

export default Collapsible;
